import { MaintenanceOrderEnums } from "src/app/enum/maintenance-order-enum";

export class MaintenanceOrderModel {
  maintenanceOrderId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  alterNumber: number | null = null;
  maintenanceOrderClassId: number = 0;
  maintenanceOrderTypeId: number = 0;
  maintenanceTypeId: number = 0;
  costCenterId: number | null = null;
  clientId: number = 0;
  transporterId: number | null = null;
  vehicleId: number | null = null;
  transportValue: number = 0;
  transportValueToPay: number = 0;
  valueToInvoiced: number = 0;
  invoiceNumber: string | null = null;
  swChargeConstructionSite: boolean = false;
  dateMaintenanceOrder: Date = new Date();
  articleId: number = 0;
  storeId: number | null = null;
  costRepairValue: number = 0;
  mechanicId: number | null = null;
  dateInitialMaintenanceOrder: Date = new Date();
  dateFinalMaintenanceOrder: Date | null = null;
  workshopType: number | null = null;
  repairHour: number = 0;
  kmHoromValue: number = 0;
  maintenanceOrderStateId: number = MaintenanceOrderEnums.abierta;
  swCostRepairState: boolean = true;
  initialDiagnosis: string | null = null;
  finalDiagnosis: string | null = null;
  swBlock: boolean = false;
  reportedBy: string | null = null;
  contactConstructionSite: string | null = null;
  receivedBy: string | null = null;
  dateCompromise: Date | null = null;
  qualificationId: number | null = null;
  swDeliveredOnTime: boolean | null = null;
  interval: number | null = null;
  maintenancePlan: number | null = null;
  consecutiveMaintenanceScheduling: number | null = null;
  dateMaintenanceScheduling: Date | null = null;
  maintenanceOrderOriginId: number | null = null;
  maintenanceOrderOriginConsecutive: number | null = null;
  devolutionDetailId: number | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;



  //Solo se usa en el front
  devolutionConsecutive: number | null = null;
}
